
import ReviewsViewLazyImage from '../../../LazyImage.vue';

export default {
  name: 'ReviewsViewTabSectionMainContentReviewsListReviewsRating',
  components: {
    ReviewsViewLazyImage,
  },
  props: {
    rating: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isImgLoaded: new Array(1).fill(false),
      imageUrl: '/skin/frontend/onestopbedrooms/default/images/review',
    };
  },
  computed: {
    reviewRatingImage() {
      return {
        src: `${this.$config.cdnBaseUrl}${this.imageUrl}/1sb-five-stars-orange-five_new.svg`,
        alt: 'Selected Star',
        sources: [],
      };
    },
  },
  methods: {
    load(index) {
      this.$set(this.isImgLoaded, index, true);
    },
  },
};
